import Dev from './Dev';

export default Dev;
